export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    slug: 'hexin-wanfa',
    name: '核心玩法',
    description: '从零开始掌握2048游戏的基础规则与核心操作机制，理解棋盘布局的底层逻辑和数学原理。',
    icon: 'ri-gamepad-line',
    articleCount: 4,
  },
  {
    slug: 'gaofen-jiqiao',
    name: '高分技巧',
    description: '系统化的高分训练方法与日常练习策略，帮助你在2048中突破万分解锁更高成就。',
    icon: 'ri-bar-chart-line',
    articleCount: 3,
  },
  {
    slug: 'hebing-celue',
    name: '合并策略',
    description: '深度解析方块合并的核心策略，包括角落战术、蛇形排列法和三方向原则等经典打法。',
    icon: 'ri-stack-line',
    articleCount: 4,
  },
  {
    slug: 'jinjie-miji',
    name: '进阶秘籍',
    description: '面向中高阶玩家的深度攻略，涵盖逆向思维、残局翻盘和心理博弈等高级技巧。',
    icon: 'ri-lightbulb-flash-line',
    articleCount: 4,
  },
  {
    slug: 'jixian-tiaozhan',
    name: '极限挑战',
    description: '挑战4096及更高目标，学习极限模式下的生存技巧，分析全球顶尖玩家的高分策略。',
    icon: 'ri-rocket-line',
    articleCount: 3,
  },
];